module.exports = __webpack_public_path__ + "assets/img/2.12f79b89.png";